export const notfoundEN = {
    message1:'Sorry, the page you were looking for was not found.',
    message2:'Application for ',
    message3:'will available '
}

export const notfoundTH = {
    message1:'ขออภัยไม่พบหน้าที่คุณกำลังค้นหา',
    message2:'เว็บไซต์สมัครเรียน ',
    message3:'ใช้งานได้ตั้งแต่วันที่ '
}